/**
 * Not Found Screen.
 */

import { Link } from 'react-router-dom';

export function NotFoundScreen() {
  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '48px', margin: '0 0 8px' }}>404</h1>
        <p className="muted mb-16">Page not found.</p>
        <Link to="/dashboard" className="btn btn--primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
